module.exports = __webpack_public_path__ + "img/more.f9583c86.svg";